/* inimu theme — global behaviours */
(function () {
  'use strict';

  /* ---------- announcement bar close ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var btn = bar.querySelector('[data-announcement-close]');
    if (!btn) return;
    if (sessionStorage.getItem('inimu:announcement-closed') === '1') {
      bar.style.display = 'none';
      return;
    }
    btn.addEventListener('click', function () {
      bar.style.display = 'none';
      sessionStorage.setItem('inimu:announcement-closed', '1');
    });
  });

  /* hero badge: 固定表示（カーソル追従・回転は廃止） */

  /* ---------- hero slider ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var nextBtns = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-next]'));
    var thumb = hero.querySelector('[data-hero-thumb] img');
    var rail = hero.querySelector('[data-hero-rail]');
    var railNew = hero.querySelector('[data-hero-rail-new]');
    var current = 0;
    var timer = null;
    var INTERVAL = 5500;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === current);
      });
      if (thumb) {
        var nextSlide = slides[(current + 1) % slides.length];
        var img = nextSlide.querySelector('img');
        if (img) thumb.src = img.currentSrc || img.src;
      }
      /* 縦書きラベルを表示中のスライドに合わせる */
      if (rail) {
        var s = slides[current];
        var href = s.getAttribute('data-hero-href');
        var label = s.getAttribute('data-hero-label');
        if (href) rail.setAttribute('href', href);
        if (label) rail.textContent = label;
        if (railNew) railNew.hidden = s.getAttribute('data-hero-new') !== 'true';
      }
    }

    function play() {
      stop();
      timer = setInterval(function () { show(current + 1); }, INTERVAL);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); play(); });
    });
    nextBtns.forEach(function (b) {
      b.addEventListener('click', function () { show(current + 1); play(); });
    });

    show(0);
    play();
  });

  /* ---------- product row carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var row = wrap.querySelector('[data-carousel-row]');
    if (!row) return;
    function step() {
      var item = row.firstElementChild;
      var g = parseFloat(getComputedStyle(row).columnGap) || 25;
      return item ? item.getBoundingClientRect().width + g : row.clientWidth / 4;
    }
    wrap.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    });
    wrap.querySelectorAll('[data-carousel-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });

    dragScroll(row);
  });

  /* マウスでもドラッグでスワイプできるようにする共通処理 */
  function dragScroll(el) {
    var down = null;
    var moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      e.preventDefault();
      down = { x: e.clientX, left: el.scrollLeft, id: e.pointerId };
      moved = false;
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - down.x;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        if (el.setPointerCapture) {
          try { el.setPointerCapture(down.id); } catch (err) {}
        }
      }
      if (moved) el.scrollLeft = down.left - dx;
    });
    ['pointerup', 'pointerleave'].forEach(function (ev) {
      el.addEventListener(ev, function () { down = null; });
    });
    el.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- image reveal on scroll ---------- */
  var revealTargets = Array.prototype.slice.call(document.querySelectorAll(
    '.fp .p-card__media, .ss__card-media, .bf__media, .sb__media, .st__photo'
  ));
  if (revealTargets.length) {
    revealTargets.forEach(function (el) { el.setAttribute('data-reveal', ''); });
    var pending = revealTargets.slice();
    var checkReveal = function () {
      if (!pending.length) return;
      var vh = window.innerHeight;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.95 && r.bottom > 0) {
          el.classList.add('is-inview');
          return false;
        }
        return true;
      });
    };
    window.addEventListener('scroll', checkReveal, { passive: true });
    window.addEventListener('resize', checkReveal, { passive: true });
    window.addEventListener('load', checkReveal);
    requestAnimationFrame(checkReveal);
    var revealTimer = setInterval(function () {
      checkReveal();
      if (!pending.length) clearInterval(revealTimer);
    }, 700);
  }

  /* ---------- scent search tabs ---------- */
  document.querySelectorAll('[data-scent-search]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-scent-tab]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-scent-group]'));
    var sel = root.querySelector('[data-scent-select]');
    if (!tabs.length) return;

    function activate(key) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-scent-tab') === key);
      });
      groups.forEach(function (g) {
        g.hidden = g.getAttribute('data-scent-group') !== key;
      });
      if (sel && sel.value !== key) sel.value = key;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-scent-tab'));
      });
    });
    if (sel) {
      sel.addEventListener('change', function () { activate(sel.value); });
    }
    function fromHash() {
      var m = /^#search-(scent|scene|item)$/.exec(location.hash);
      if (!m || !root.querySelector('[data-scent-tab="' + m[1] + '"]')) return;
      activate(m[1]);
      root.scrollIntoView();
    }
    window.addEventListener('hashchange', fromHash);
    fromHash();
    groups.forEach(function (g) { dragScroll(g); });
  });

  /* ---------- brand panes: mouse drag swipe ---------- */
  document.querySelectorAll('[data-brand-feature] .bf__stage').forEach(function (el) {
    dragScroll(el);
  });
})();
